import React, { FC } from 'react';
import { Col, Row } from 'reactstrap';

import classNames from '../../helpers/classNames';
import { MappedGolfCourseType } from '../../services/apis/golfCourses/types';
import GolfCourseCard from '../GolfCourseCard/GolfCourseCard';

interface CoursesListPropsType {
  courses: MappedGolfCourseType[];
  topRatedGolfCourses?: MappedGolfCourseType[];
  topBookedGolfCourses?: MappedGolfCourseType[];
  isAccommodation?: boolean;
  className?: string;
}

const CoursesList: FC<CoursesListPropsType> = props => {
  const {
    courses,
    topRatedGolfCourses = [],
    topBookedGolfCourses = [],
    isAccommodation,
    className,
  } = props;

  return (
    <Row className={classNames('gy-4', className)}>
      {courses.map(course => (
        <Col key={course.id} xs={12} md={6} lg={4} className="d-flex align-items-stretch">
          <GolfCourseCard
            golfCourse={course}
            isAccommodation={isAccommodation}
            topRated={topRatedGolfCourses.some(
              ({ golfCourse: { id } }) => id === course.golfCourse.id
            )}
            topBooked={topBookedGolfCourses.some(
              ({ golfCourse: { id } }) => id === course.golfCourse.id
            )}
          />
        </Col>
      ))}
    </Row>
  );
};

export default CoursesList;
